import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import { StickyContainer, Sticky } from "react-sticky";
import { scrollToHash } from "src/lib/scroll-to-hash";
import formatCurrency from "src/lib/format-currency";
import {
  getSelectedProducts,
  getGiftsTotal,
  getGiftsProductsPayload,
  getGiftsSubTotal,
  getGiftsProductSKUs,
  getIsGiftOffer,
} from "src/redux/gifts/selectors";
import Container from "src/react/layout/container";
import { LinkButton } from "src/react/components/link";
import { color } from "src/styles/variables";
import BlackFridayBanner from "src/react/components/sticky-banner/black-friday-banner";
import Hero from "./hero";
import GiftsProducts from "./products";

class Gifts extends Component {
  static propTypes = {
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.object,
    history: PropTypes.object,
    total: PropTypes.number,
    subTotal: PropTypes.number,
    selectedProducts: PropTypes.array,
    productSKUs: PropTypes.array,
    isGiftOffer: PropTypes.bool,
  };

  static defaultProps = {
    location: {},
    history: {},
    match: { path: "" },
  };

  state = {
    address: null,
    shouldShowPayment: false,
    error: null,
  };

  componentDidMount() {
    scrollToHash();
  }

  render() {
    const { selectedProducts, total, isGiftOffer, match } = this.props;
    const hasProducts = selectedProducts.length > 0;
    return (
      <StickyContainer>
        <BlackFridayBanner noLink={true} />
        <div style={{ position: "relative", zIndex: 20 }}>
          {hasProducts && (
            <Sticky>
              {({ style }) => (
                <GiftsBasketSummary
                  data-selector="GiftsBasketSummary"
                  style={style}
                >
                  <Container>
                    <LinkButton
                      variant="outlineSecondary"
                      align="center"
                      to={`${match.path}/basket`}
                    >
                      Review basket - {formatCurrency({ value: total })} total
                    </LinkButton>
                  </Container>
                </GiftsBasketSummary>
              )}
            </Sticky>
          )}
        </div>
        {!isGiftOffer && <Hero />}
        <GiftsProducts selectedProducts={selectedProducts} />
      </StickyContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedProducts: getSelectedProducts(state),
  total: getGiftsTotal(state),
  productsPayload: getGiftsProductsPayload(state),
  subTotal: getGiftsSubTotal(state),
  productSKUs: getGiftsProductSKUs(state),
  isGiftOffer: getIsGiftOffer(state),
});

export default connect(mapStateToProps)(Gifts);

const GiftsBasketSummary = styled.div`
  padding: 10px 0;
  background: ${color.mineShaft};
`;
